import { useEffect, useState } from 'react';
import { demeterNewsApi } from '../../../Apis/Apis';
import CacheKeys from '../../Services/Cache/CacheKeys';
import useLanguage from '../../Services/Language/useLanguageHook';
import useCacheThenApi from './useCacheThenApiHook';

const useCommentaryApi = (demeterCommentaryGuid?: string | null): string => {
    const [commentary, setCommentary] = useState('');
    const [, , language] = useLanguage();

    const [loading, refreshApi, commentaryResponse, commentaryError] = useCacheThenApi(
        `${CacheKeys.GetDemeterCommentary}_${demeterCommentaryGuid}_${language}`,
        () => {
            if (!demeterCommentaryGuid) {
                return null;
            }

            return demeterNewsApi.getDemeterCommentary(demeterCommentaryGuid, language);
        },
        {
            stopGlobalErrorHandling: true,
        },
    );

    useEffect(() => {
        if (!demeterCommentaryGuid) {
            return;
        }

        refreshApi();
    }, [demeterCommentaryGuid, language]);

    useEffect(() => {
        if (loading || commentaryError) {
            setCommentary('');
            return;
        }

        setCommentary(commentaryResponse?.commentary?.content ?? '');
    }, [loading, commentaryResponse, commentaryError]);

    return commentary;
};

export default useCommentaryApi;
